<template>
  <div class="aboutWrapper111">
    <p>有生命力的团队</p>
    <p>我们欣赏专业领域的好奇心以及解决问题的执着较真。</p>
    <p>
      我们为才华横溢的头脑提供一流的平台，我们相信，会拼会玩会生活有温度的团队，将会成为无可比拟的财富。
    </p>
    <el-carousel :interval="2000" type="card" height="400px">
      <el-carousel-item v-for="item in imgList" :key="item">
        <img :src="item"  alt="" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import dwgwcontenheader from "@/components/dwgwcontenheader";
export default {
  name: "dwgwteam",
  components: { dwgwcontenheader },
  data() {
    return {
      img: require("./jpg/index1_3.png"),
      imgList: [
        require("./jpg/2.jpg"),
        require("./jpg/3.jpg"),
        require("./jpg/4.jpg"),
        require("./jpg/5.jpg"),
        require("./jpg/6.jpg"),
        require("./jpg/7.jpg"),
        require("./jpg/8.jpg"),
        require("./jpg/9.jpg"),
        require("./jpg/10.jpg"),
        require("./jpg/11.jpg"),
        require("./jpg/12.jpg"),
      ],
    };
  },
};
</script>

<style>
.aboutWrapper111 {
  width: 1140px;
  margin: 0 auto;
  padding-top: 20px;
}
.aboutWrapper111 > p {
  font-size: 18px;
  line-height: 45px;
  padding-bottom: 20px;
}
.el-carousel__item  img{
    height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/dwgwteam.vue